import React from 'react';
import { cn } from './cn';

export function FieldLabel({ className, required, children, ...props }: React.LabelHTMLAttributes<HTMLLabelElement> & { required?: boolean }) {
  return (
    <label className={cn('mb-1.5 block text-[11px] font-bold text-ds-700', className)} {...props}>
      {children}{required && <span className="mr-1 text-ds-primary" aria-hidden="true">*</span>}
    </label>
  );
}

export const fieldClassName = 'h-11 w-full rounded-ds-8 border border-ds-200 bg-ds-white px-3 text-[13px] text-ds-ink placeholder:text-ds-400 focus:border-ds-primary focus:outline-none focus:ring-[3px] focus:ring-ds-primary-ring';

export const TextField = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  function TextField({ className, ...props }, ref) {
    return <input ref={ref} className={cn(fieldClassName, className)} {...props} />;
  },
);

export const TextAreaField = React.forwardRef<HTMLTextAreaElement, React.TextareaHTMLAttributes<HTMLTextAreaElement>>(
  function TextAreaField({ className, ...props }, ref) {
    return <textarea ref={ref} className={cn(fieldClassName, 'min-h-24 resize-y py-3', className)} {...props} />;
  },
);
